import { OrganizationDto } from "../../common/service/server/dto/OrganizationDto";

/**
 * Determine whether features like Cookie Scan or Consent Record Lookup should be shown to the user for the org.
 * @param org
 */
export const useOrganizationFeatureCookieConsent: (org: OrganizationDto) => boolean = (
  org: OrganizationDto,
) => {
  return org.featureGdpr || org.featurePipeda || org.pseudoFeatureCookieConsent;
};
